module.exports = __webpack_public_path__ + "img/xamarin.7ff69559.png";